import AvailabilityForm from "./AvailabilityForm"
import ExceptionsManager from "./ExceptionsManager"
import { UnderlineTabs } from "@ui/UnderlineTabs"

export default function InstructorView({ courseId }) {
  return (
    <UnderlineTabs.Root defaultValue="availability">
      <UnderlineTabs.List className="mb-6">
        <UnderlineTabs.Tab value="availability">Availability</UnderlineTabs.Tab>
        <UnderlineTabs.Tab value="exceptions">Exceptions</UnderlineTabs.Tab>
      </UnderlineTabs.List>
      <UnderlineTabs.Panel value="availability">
        <AvailabilityForm courseId={courseId} />
      </UnderlineTabs.Panel>
      <UnderlineTabs.Panel value="exceptions">
        <ExceptionsManager courseId={courseId} />
      </UnderlineTabs.Panel>
    </UnderlineTabs.Root>
  )
}
